import styled from '@emotion/styled';
import { css } from 'emotion';
import { inject, observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import React from 'react';
import Dropzone from 'react-dropzone';
import { TLCode } from '../../../common/enums';
import { MunicipalityStore } from '../../../store/MunicipalityStore';
import FileLoadingModal from '../../common/modals/FileLoadingModal';
import TranslatedMessage from '../../common/translation/TranslatedMessage';
import withTranslate, { WithTranslateProps } from '../../common/WithTranslate';

interface MunicipalityUploadProps extends WithTranslateProps {
  MunicipalityStore?: Instance<typeof MunicipalityStore>;
}

interface MunicipalityUploadState {
  fileIsLoading?: boolean;
  modalFileLoadingOpened: boolean;
  importErrors: string[];
  modalTitleTLCode: TLCode;
}

@inject('MunicipalityStore')
@observer
class MunicipalityUpload extends React.Component<MunicipalityUploadProps, MunicipalityUploadState> {
  state = {
    fileIsLoading: false,
    modalFileLoadingOpened: false,
    importErrors: [],
    modalTitleTLCode: TLCode.FILE_LOADING_MODAL_MUNICIPALITIES_TITLE,
  } as MunicipalityUploadState;

  cleanupBuffer = (buffer) => {
    return buffer.substring(39, 100).replace(/\//g, '-');
  };

  onImportModalClose = () => {
    this.setState({
      modalFileLoadingOpened: false,
      fileIsLoading: false,
    });
  };

  UploadMunicipalitiesFile = async (file: File) => {
    return this.props.MunicipalityStore!.uploadMunicipalityFile(file);
  };

  UploadStatbelPostalCodeFile = async (file: File) => {
    return this.props.MunicipalityStore!.uploadPostalCodesFile(file);
  };

  UploadBpostPostalCodeFile = async (file: File) => {
    return this.props.MunicipalityStore!.uploadPostalCodesFile(file, 'bpost');
  };

  UploadPopulationFile = async (file: File) => {
    return this.props.MunicipalityStore!.uploadPopulationFile(file);
  };

  DropZoneWithUpload = (uploadFile: (file) => Promise<void>, titleTLCode: TLCode) => {
    return (
      <Dropzone
        multiple={false}
        onDrop={(acceptedFiles) => {
          const reader = new FileReader();
          reader.onload = () => {
            // Do whatever you want with the file contents
            const binaryStr = reader.result;
            const buffer = binaryStr!.toString();
            this.cleanupBuffer(buffer);
          };
          acceptedFiles.forEach(async (file) => {
            this.setState({ fileIsLoading: true, modalFileLoadingOpened: true, modalTitleTLCode: titleTLCode });
            const errors = await uploadFile(file);
            // @ts-ignore
            this.setState({ fileIsLoading: false, importErrors: errors });
          });
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()} className={boxed.toString()}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop ici d'un fichier CSV, ou cliquer pour sélectionner un fichier</p>
              <p>Le fichier ne doit contenir qu'une seule feuille (sheet)</p>
            </div>
          </section>
        )}
      </Dropzone>
    );
  };

  render() {
    const { fileIsLoading, modalFileLoadingOpened, importErrors } = this.state;

    return (
      <Container>
        <TranslatedMessage id={TLCode.TRANSFER_UploadMunicipalities} />
        &nbsp;
        {this.DropZoneWithUpload(this.UploadMunicipalitiesFile, TLCode.FILE_LOADING_MODAL_MUNICIPALITIES_TITLE)}
        &nbsp;
        <TranslatedMessage id={TLCode.TRANSFER_UploadZipCodesStatbel} />
        &nbsp;
        {this.DropZoneWithUpload(this.UploadStatbelPostalCodeFile, TLCode.FILE_LOADING_MODAL_ZIP_CODE_TITLE)}
        &nbsp;
        <TranslatedMessage id={TLCode.TRANSFER_UploadZipCodesBpost} />
        &nbsp;
        {this.DropZoneWithUpload(this.UploadBpostPostalCodeFile, TLCode.FILE_LOADING_MODAL_ZIP_CODE_TITLE)}
        &nbsp;
        <TranslatedMessage id={TLCode.TRANSFER_UploadPopulations} />
        &nbsp;
        {this.DropZoneWithUpload(this.UploadPopulationFile, TLCode.FILE_LOADING_MODAL_POPULATION_TITLE)}
        <FileLoadingModal
          fileIsLoading={fileIsLoading}
          modalOpened={modalFileLoadingOpened}
          onClosed={this.onImportModalClose}
          errors={importErrors}
          titleFileLoadingTranslationCode={this.state.modalTitleTLCode}
        />
      </Container>
    );
  }
}

export default withTranslate(MunicipalityUpload);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const boxed = css({
  border: '1px solid green',
  height: '120px',
  width: '80%',
});
